<template>
    <kgr-profile-part
        v-if="!isEmpty"
        :heading="$t('Kontaktdaten')"
    >
        <template #content>
            <dl class="kgr-definitionList kgr-definitionList--horizontal kgr-definitionList--200">
                <template v-if="addressIsDefined">
                    <dt
                        v-t="'Adresse'"
                        class="kgr-definitionList__term"
                    ></dt>
                    <dd class="kgr-definitionList__definition">
                        <kgr-member-address :member="memberShortProfile" />
                    </dd>
                </template>
                <template v-if="memberShortProfile.company">
                    <dt
                        v-t="'member.company'"
                        class="kgr-definitionList__term"
                    ></dt>
                    <dd class="kgr-definitionList__definition">
                        {{ memberShortProfile.company }}
                    </dd>
                </template>
                <template v-if="memberShortProfile.phone">
                    <dt
                        v-t="'member.phone'"
                        class="kgr-definitionList__term"
                    ></dt>
                    <dd class="kgr-definitionList__definition">
                        {{ memberShortProfile.phone }}
                    </dd>
                </template>
                <template v-if="memberShortProfile.phoneBusiness">
                    <dt
                        v-t="'member.phoneBusiness'"
                        class="kgr-definitionList__term"
                    ></dt>
                    <dd class="kgr-definitionList__definition">
                        {{ memberShortProfile.phoneBusiness }}
                    </dd>
                </template>
                <template v-if="memberShortProfile.phoneMobile">
                    <dt
                        v-t="'member.phoneMobile'"
                        class="kgr-definitionList__term"
                    ></dt>
                    <dd class="kgr-definitionList__definition">
                        {{ memberShortProfile.phoneMobile }}
                    </dd>
                </template>
                <template v-if="memberShortProfile.phoneMobileBusiness">
                    <dt
                        v-t="'member.phoneMobileBusiness'"
                        class="kgr-definitionList__term"
                    ></dt>
                    <dd class="kgr-definitionList__definition">
                        {{ memberShortProfile.phoneMobileBusiness }}
                    </dd>
                </template>
                <template v-if="memberShortProfile.emergencyContact">
                    <dt
                        v-t="'member.emergencyContact'"
                        class="kgr-definitionList__term"
                    ></dt>
                    <dd class="kgr-definitionList__definition">
                        {{ memberShortProfile.emergencyContact }}
                    </dd>
                </template>
                <template v-if="memberShortProfile.email">
                    <dt
                        v-t="'member.email'"
                        class="kgr-definitionList__term"
                    ></dt>
                    <dd class="kgr-definitionList__definition">
                        <a
                            :href="`mailto:${memberShortProfile.email}`"
                            class="kgr-link"
                        >
                            {{ memberShortProfile.email }}
                        </a>
                    </dd>
                </template>
                <template v-if="memberShortProfile.emailBusiness">
                    <dt
                        v-t="'member.emailBusiness'"
                        class="kgr-definitionList__term"
                    ></dt>
                    <dd class="kgr-definitionList__definition">
                        <a
                            :href="`mailto:${memberShortProfile.emailBusiness}`"
                            class="kgr-link"
                        >
                            {{ memberShortProfile.emailBusiness }}
                        </a>
                    </dd>
                </template>
            </dl>
        </template>
    </kgr-profile-part>
</template>

<script>
import MemberAddress from '../MemberAddress';
import MemberShortProfile from '../../../js/dto/MemberShortProfile';
import ProfilePart from '../../short-profile/ProfilePart';

export default {
    name: 'kgr-member-part-contact',
    components: {
        'kgr-member-address': MemberAddress,
        'kgr-profile-part': ProfilePart,
    },
    props: {
        memberShortProfile: {
            type: MemberShortProfile,
            required: true,
        },
    },
    computed: {
        addressIsDefined() {
            return this.memberShortProfile.street && (this.memberShortProfile.zip || this.memberShortProfile.city);
        },
        isEmpty() {
            return !this.addressIsDefined
                && !this.memberShortProfile.phone
                && !this.memberShortProfile.phoneMobile
                && !this.memberShortProfile.email;
        },
    },
};
</script>

<style scoped lang="scss" rel="stylesheet/scss">

</style>
